// extracted by mini-css-extract-plugin
export default {"Container":"styles_Container__DPH62","section-1":"styles_section-1__Ilv2Y","content":"styles_content__QuJLh","section-2":"styles_section-2__YUqIx"};